export const ROLES = {
  ADMIN: "admin",
  SUB_ADMIN: "sub_admin",
  RECEPTIONIST: "receptionist",
  DOCTOR: "doctor",
  LABORATORY: "laboratory",
};

export const getUserRole = () => {
  if (typeof window === "undefined") return null;
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.role || (user?.isAdmin ? ROLES.ADMIN : null);
  } catch {
    return null;
  }
};

export const getCurrentUser = () => {
  if (typeof window === "undefined") return null;
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
};

export const hasRole = (requiredRole) => getUserRole() === requiredRole;

export const hasAnyRole = (roles) => roles.includes(getUserRole());

export const isAdmin = () => {
  const user = getCurrentUser();
  return user?.isAdmin === true || hasRole(ROLES.ADMIN);
};

export const isSubAdmin = () => hasRole(ROLES.SUB_ADMIN);

export const isAdminOrSubAdmin = () => isAdmin() || isSubAdmin();

export const isReceptionist = () => hasRole(ROLES.RECEPTIONIST);
export const isDoctor = () => hasRole(ROLES.DOCTOR);
export const isLaboratory = () => hasRole(ROLES.LABORATORY);

export const getRoleDisplayName = (role) => {
  const displayNames = {
    [ROLES.ADMIN]: "Administrator",
    [ROLES.RECEPTIONIST]: "Receptionist",
    [ROLES.DOCTOR]: "Doctor",
    [ROLES.LABORATORY]: "Laboratory Admin",
  };
  return displayNames[role] || role;
};
